import * as React from "react";

const TailRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={33} height={18} viewBox="0 0 33 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M33 0C28.2849 1.31559 23.9035 5.19389 20.1506 9.44425C16.0128 14.0994 9.1416 16.988 0 18V0H33Z"  />
    </svg>
  );
};

export default TailRight;
